import { Link, useNavigate } from 'react-router-dom';
import { useCarrito, useActualizarItemCarrito, useEliminarItemCarrito } from '../../hooks/useCarrito';
import { CartLineItem } from '../../components/public/CartLineItem';
import { Button } from '../../components/shared/Button';
import { Spinner } from '../../components/shared/Spinner';

export function CarritoPage() {
  const { data: carrito, isLoading } = useCarrito();
  const actualizarItem = useActualizarItemCarrito();
  const eliminarItem = useEliminarItemCarrito();
  const navigate = useNavigate();

  if (isLoading) return <Spinner />;

  const lineas = carrito?.lineas ?? [];

  return (
    <section className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-14 py-8 md:py-11 flex flex-col md:flex-row gap-8 md:gap-11 items-start">
      <div className="w-full md:flex-[2] flex flex-col gap-6">
        <h1 className="text-3xl md:text-4xl font-display font-semibold text-[oklch(28%_0.03_50)]">Tu Carrito</h1>

        {lineas.length === 0 ? (
          <p className="text-ink-muted">
            Tu carrito está vacío. <Link to="/catalogo" className="font-semibold">Ver catálogo</Link>
          </p>
        ) : (
          <div className="flex flex-col gap-4">
            {lineas.map((linea) => (
              <CartLineItem
                key={linea.id}
                linea={linea}
                onCambiarCantidad={(cantidad) =>
                  actualizarItem.mutate({ lineaId: linea.id, cantidadDePaquetes: cantidad })
                }
                onEliminar={() => eliminarItem.mutate(linea.id)}
              />
            ))}
          </div>
        )}
      </div>

      {lineas.length > 0 && (
        <div className="w-full md:flex-1 md:max-w-[360px] flex flex-col gap-5 bg-surface border border-border rounded-xl p-6 md:p-7 md:sticky md:top-6">
          <h2 className="text-xl font-display font-semibold text-[oklch(28%_0.03_50)]">Resumen</h2>
          <div className="flex justify-between text-sm text-ink-muted">
            <span>Subtotal ({lineas.length} artículos)</span>
            <span>S/ {carrito!.total.toFixed(2)}</span>
          </div>
          <div className="border-t border-border pt-3.5 flex justify-between text-lg font-bold">
            <span>Total</span>
            <span>S/ {carrito!.total.toFixed(2)}</span>
          </div>
          <p className="text-xs text-ink-muted leading-relaxed">
            El pago se coordina directamente contigo por WhatsApp al finalizar tu pedido.
          </p>
          <Button onClick={() => navigate('/checkout')} data-testid="checkout-button">
            Finalizar compra
          </Button>
        </div>
      )}
    </section>
  );
}
